import { getProjectOverview } from '@/services/projects';
import { Dispatch } from 'redux';
import { setProjectOverview } from './actions';
import { getCommentsOverview } from '@/services/comments';

export const loadProjectOverview = async (dispatch: Dispatch, projectId: number) => {
    const projectOverview = await getProjectOverview(projectId);
    const commentsOverview = await getCommentsOverview({ projectIds: [projectId] });
    setProjectOverview(dispatch, {
        changeRequests: projectOverview.changeRequests,
        tasks: projectOverview.tasks,
        comments: commentsOverview,
        projectId: projectId,
        total: 0,
    });
};
